import { get, put, toQueryParams } from '@/lib/http';
import { endpoints } from './endpoints';
import type { LotCommercialInfo, LotCommercialInfoRequest, Page, PageRequest } from '@/types';

export interface CommercialInfoQuery extends PageRequest {
  buyerId?: number;
  poId?: number;
  search?: string;
}

export const commercialInfoApi = {
  /** Every fully-dispatched lot, filled in or still awaiting commercial info. */
  list: (query: CommercialInfoQuery = {}) =>
    get<Page<LotCommercialInfo>>(endpoints.commercialInfo.list, {
      params: toQueryParams({ page: 0, size: 10, ...query }),
    }),

  byLot: (lotId: number) => get<LotCommercialInfo>(endpoints.commercialInfo.byLot(lotId)),

  /**
   * Enters (first time, needs COMMERCIAL_INFO_CREATE) or edits (needs
   * COMMERCIAL_INFO_EDIT) a lot's commercial info — the backend picks the rule.
   */
  upsert: (lotId: number, body: LotCommercialInfoRequest) =>
    put<LotCommercialInfo, LotCommercialInfoRequest>(endpoints.commercialInfo.byLot(lotId), body),
};
